/* 
* <license header>
*/

/* global fetch */

/**
 *
 * Invokes a web action
 *
 * @param  {string} actionUrl
 * @param {object} headers
 * @param  {object} params
 *
 * @returns {Promise<string|object>} the response
 *
 */

async function actionWebInvoke (actionUrl, headers = {}, params = {}, options = { method: 'POST' }) {
  const actionHeaders = {
    'Content-Type': 'application/json',
    ...headers
  }

  const fetchConfig = {
    headers: actionHeaders
  }

  if (window.location.hostname === 'localhost' || window.location.hostname.indexOf('stage.adobeio-static.net') >= 0) {
    actionHeaders['x-ow-extra-logging'] = 'on'
  }

  fetchConfig.method = options.method.toUpperCase()

  if (fetchConfig.method === 'GET') {
    actionUrl = new URL(actionUrl)
    Object.keys(params).forEach(key => actionUrl.searchParams.append(key, params[key]))
  } else if (fetchConfig.method === 'POST') {
    fetchConfig.body = JSON.stringify(params)
  }

  const response = await fetch(actionUrl, fetchConfig)

  let content = await response.text()

  if (!response.ok) {
    throw new Error(`failed request to '${actionUrl}' with status: ${response.status} and message: ${content}`)
  }
  try {
    content = JSON.parse(content)
  } catch (e) {
    // response is not json
  }
  return content
}

function getHeaders(ims, oktaAccessToken) {
  const headers = {};

  // set the authorization header and org from the ims props object
  if (typeof oktaAccessToken === "string") {
    headers.authorization = `Bearer ${oktaAccessToken}`;
  } else if (typeof oktaAccessToken === "object") {
    headers.authorization = `Bearer ${oktaAccessToken.accessToken}`;
  } else {
    // eslint-disable-next-line no-undef
    alert(
      "It appears that you are not logged in to Adobe Okta or your section has expired. This submission will likely fail. Please refresh, log in and try again."
    );
  }

  if (ims?.org && !headers["x-gw-ims-org-id"]) {
    headers["x-gw-ims-org-id"] = ims.org;
  }


  return headers;
}

export default actionWebInvoke
export { getHeaders }